import { Injectable } from "@angular/core";

import { SQLConfig, StandardSQL, keywordCompletionSource } from "@codemirror/lang-sql";
import { CompletionSource, CompletionResult, CompletionContext } from "@codemirror/autocomplete";

import { SqlLanguageSpec } from "../models";
import { CodeEditorBlock } from "../../models";
import { SqlEditorLanguageConfigService } from "./sql-editor-language-config.service";


@Injectable()
export class SqlEditorKeywordCompletionService {

    constructor(private configurationService: SqlEditorLanguageConfigService) {
    }

    public getKeywordCompletionSource(spec?: SqlLanguageSpec): CompletionSource {
        const config: SQLConfig = this.configurationService.getSqlConfiguration(spec);

        const source: CompletionSource = keywordCompletionSource(
            config?.dialect ?? StandardSQL,
            config?.upperCaseKeywords,
            config?.keywordCompletion
        );

        return context => this.keywordAutocomplete(source, context);
    }

    private async keywordAutocomplete(source: CompletionSource, context: CompletionContext): Promise<CompletionResult> {
        try {
            if (!source || !context) return null;

            // Get the block of text preceding the cursor.
            const before: CodeEditorBlock = this.getBeforeBlock(context);

            // Prevent the @codemirror/lang-sql bug that causes keyword completion to trigger after dots.
            if (!before || before.text.includes(".")) return null;

            return source(context);

        } catch (error) {
            return null;
        }
    }

    private getBeforeBlock(context: CompletionContext): CodeEditorBlock {
        return context.matchBefore(/\S+$/);
    }
}